import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { baseUrl, getDateWithDay } from "../../comman/config";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../components/Loader";
import NoRecordsFound from "../../components/NoRecordsFound";

function PurchaseSummary() {
  const today = new Date().toISOString().split("T")[0];
  const [purchaseDate, setPurchaseDate] = useState(today);
  const [purchaseSummary, setPurchaseSummary] = useState([]);
  const [totalPurchaseValue, setTotalPurchaseValue] = useState(0);
  const [labour, setLabour] = useState(null);
  const [chaiPani, setChaiPani] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noRecordsFound, setNoRecordsFound] = useState(false);

  //   useEffect(() => {
  //     getPurchaseSummary();
  //   }, [purchaseDate]);

  useEffect(() => {
    calculateTotal();
  }, [purchaseSummary, labour, chaiPani]);

  const getPurchaseSummary = async () => {
    setLoading(true);
    setNoRecordsFound(false);
    try {
      const response = await axios.post(`${baseUrl}/purchase/summary`, {
        date: purchaseDate
      });
      console.log("data response:", response.data.data)
      if (response.data.data && response.data.data.length > 0) {
        setPurchaseSummary(response.data.data);
        setLabour(response.data.data[0]?.labour ?? 0);
        setChaiPani(response.data.data[0]?.chai_pani ?? 0);
        setNoRecordsFound(false);
      } else {
        setPurchaseSummary([]);
        setLabour(0);
        setChaiPani(0);
        setNoRecordsFound(true);
      }
    } catch (error) {
      console.error("Error fetching purchase summary:", error);
      toast.error("Failed to fetch purchase summary data");
      setNoRecordsFound(true);
    } finally {
      setLoading(false);
    }
  };

const calculateTotal = () => {
  let vegPurchaseValue = purchaseSummary.reduce(
    (sum, item) => sum + parseFloat(item.total_value || 0),
    0
  );

  const labourFromSummary = purchaseSummary[0]?.labour;
  const chaiPaniFromSummary = purchaseSummary[0]?.chai_pani;

  const effectiveLabour = labourFromSummary !== undefined && labourFromSummary !== null
    ? parseFloat(labourFromSummary)
    : parseFloat(labour || 0);

  const effectiveChaiPani = chaiPaniFromSummary !== undefined && chaiPaniFromSummary !== null
    ? parseFloat(chaiPaniFromSummary)
    : parseFloat(chaiPani || 0);

  setTotalPurchaseValue(vegPurchaseValue + effectiveLabour + effectiveChaiPani);
};


  const handleLabourChange = (e) => {
    const value = e.target.value === "" ? 0 : parseFloat(e.target.value);
    setLabour(value);
  };

  const handleChaiPaniChange = (e) => {
    const value = e.target.value === "" ? 0 : parseFloat(e.target.value);
    setChaiPani(value);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const payload = {
        date: purchaseDate,
        labour: labour,
        chai_pani: chaiPani,
        veg_purchase_value: totalPurchaseValue - labour - chaiPani,
        total_purchase_value: totalPurchaseValue
      };

      const response = await axios.post(`${baseUrl}/purchase/save-summary`, payload);

      if (response.data.status) {
        toast.success("Purchase summary saved successfully");
      } else {
        toast.error("Failed to save purchase summary");
      }
    } catch (error) {
      console.error("Error saving purchase summary:", error);
      toast.error("Failed to save purchase summary");
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    try {
      // Create worksheet data including headers
      const worksheetData = [
        ["Purchase Date", purchaseDate],
        [],
        ["Sr.no.", "શાકભાજી નામ", "ઓર્ડર જથ્થો", "ખરીદ જથ્થો", "પેક", "Rate / kgs. (Rs.)", "કુલ મૂલ્ય (Rs.)"],
        ...purchaseSummary.map((item, index) => [
          index + 1,
          item.ingredient,
          item.total_order || "",
          item.purchase_qty || "",
          item.pur_pack_nos || "",
          item.avg_rate || "",
          item.total_value || ""
        ]),
        [],
        ["", "", "", "", "", "Veg. Purchase Value", purchaseSummary.reduce((sum, item) => sum + parseFloat(item.total_value || 0), 0)],
      ];

      // Only add labour if it exists
      if (purchaseSummary[0]?.labour || labour) {
        worksheetData.push([
          "", "", "", "", "", "Labour",
          purchaseSummary[0]?.labour || labour || ""
        ]);
      }

      // Only add chai-pani if it exists
      if (purchaseSummary[0]?.chai_pani || chaiPani) {
        worksheetData.push([
          "", "", "", "", "", "Chai-pani",
          purchaseSummary[0]?.chai_pani || chaiPani || ""
        ]);
      }

      // Add total only if either labour or chai-pani exists
      if (totalPurchaseValue > 0) {
        worksheetData.push([
          "", "", "", "", "", "Total Purchase",
          totalPurchaseValue
        ]);
      }
      // Create a new workbook and add a worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Summary");

      // Generate Excel file
      const fileName = `Purchase_Summary_${purchaseDate}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      toast.success("Export successful");
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data");
    }
  };

  const handleClear = () => {
    setPurchaseDate(today);
    getPurchaseSummary();
  };

  return (
    <div className="p-0 sm:p-6">
      {loading && <Loader />}

      {/* Heading */}
      <div className="py-0 sm:py-2">
        <h1 className="text-base sm:text-lg md:text-xl lg:text-xl xl:text-2xl font-bold">
          Purchase Voucher
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
      </div>

      {/* Date + Buttons in same row */}
      <div className="flex flex-col sm:flex-row items-start sm:items-end gap-2 sm:gap-4 mb-4 sm:mb-6">
        <div className="w-full sm:w-auto">
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            Purchase Date
          </label>
          <input
            type="date"
            value={purchaseDate}
            onChange={(e) => setPurchaseDate(e.target.value)}
            className="px-2 py-2 border border-gray-300 rounded-md w-full sm:w-48 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-base"
          />
        </div>

        <div className="flex flex-row gap-2 w-full sm:w-auto">
          <button
            onClick={getPurchaseSummary}
            className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200 text-xs sm:text-base flex-1 sm:flex-none"
          >
            Submit
          </button>
        </div>
      </div>

      {noRecordsFound && <NoRecordsFound />}

      {purchaseSummary.length > 0 && (
        <div className="overflow-x-auto">
          <div className="w-full">
            <table className="w-full border-collapse border border-gray-300 text-xs">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-black text-center p-1 w-8">No.</th>
                  <th className="border border-black text-center p-1">શાકભાજી</th>
                  <th className="border border-black text-center p-1">ખરીદ</th>
                  <th className="border border-black text-center p-1">પેક</th>
                  <th className="border border-black text-center p-1 w-16">Rate</th>
                  <th className="border border-black text-center p-1 w-20">મૂલ્ય</th>
                </tr>
              </thead>
              <tbody className="max-h-screen overflow-y-auto">
                {/* Display only 15 rows for mobile */}
                {purchaseSummary.slice(0, 15).map((item, index) => (
                  <tr key={index} className="border border-black-b">
                    <td className="border border-black text-center p-1">{index + 1}</td>
                    <td className="border border-black text-center p-1">{item.ingredient}</td>
                    <td className="border border-black text-center p-1">{item.purchase_qty ? parseFloat(item.purchase_qty).toFixed(0) : ""}</td>
                    <td className="border border-black text-center p-1">{item.pur_pack_nos ? parseFloat(item.pur_pack_nos) : ""}</td>
                    <td className="border border-black text-center p-1">
                      {item.avg_rate ? parseFloat(item.avg_rate).toFixed(0) : ""}
                    </td>
                    <td className="border border-black text-center p-1">
                      {item.total_value ? parseFloat(item.total_value).toFixed(0) : ""}
                    </td>
                  </tr>
                ))}

                {/* Summary Rows */}
                <tr>
                  <td colSpan="2" className="border border-black"></td>
                  <td colSpan="3" className="border border-black text-center font-bold p-1">
                    <span className="whitespace-normal">Veg. Val</span>
                  </td>
                  <td className="border border-black text-center font-bold p-1">
                    {purchaseSummary.reduce((sum, item) => sum + parseFloat(item.total_value || 0), 0).toFixed(0)}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="border border-black"></td>
                  <td colSpan="3" className="border border-black text-center font-bold p-1">Labour</td>
                  <td className="border border-black text-center bg-yellow-100 p-1">
                    <input
                      type="number"
                      value={labour}
                      onChange={handleLabourChange}
                      className="border rounded-md w-full h-8 bg-orange-50 text-center text-xs"
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="border border-black"></td>
                  <td colSpan="3" className="border border-black text-center font-bold p-1">Chai</td>
                  <td className="border border-black text-center bg-yellow-100 p-1">
                    <input
                      type="number"
                      value={chaiPani}
                      onChange={handleChaiPaniChange}
                      className="border rounded-md w-full h-8 bg-orange-50 text-center text-xs"
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="border border-black"></td>
                  <td colSpan="3" className="border border-black text-center font-bold p-1">Total</td>
                  <td className="border border-black text-center font-bold p-1">
                    {totalPurchaseValue.toFixed(0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="flex flex-row justify-start space-x-2 mt-4">
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200 text-xs sm:text-base"
            >
              Save
            </button>
            <button
              onClick={handleExport}
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200 text-xs sm:text-base"
            >
              Export
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PurchaseSummary;